import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function StartFundraiser() {
  const { user, authLoading } = useApp();
  const nav = useNavigate();
  const [form, setForm] = useState({ title: "", organizer_name: "", description: "", goal_amount: 1000, category: "AAC Tablet", image_url: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800" });
  const [busy, setBusy] = useState(false);

  if (authLoading) return <div className="max-w-3xl mx-auto px-6 py-16">Loading...</div>;
  if (!user) return (
    <div className="max-w-md mx-auto px-6 py-16 text-center card-soft mt-10">
      <h1 className="font-display text-2xl font-bold">Sign in to start a fundraiser</h1>
      <Link to="/login" className="btn-pink mt-4 inline-block">Sign in</Link>
    </div>
  );

  const change = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/fundraisers", { ...form, goal_amount: parseFloat(form.goal_amount) });
      toast.success("Fundraiser created");
      nav(`/fundraisers/${data.fundraiser_id}`);
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-10" data-testid="start-fundraiser-page">
      <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">Start a Fundraiser</h1>
      <p className="text-slate-600 mt-2">Families, schools, and clinics can raise funds for autism support needs.</p>
      <form onSubmit={submit} className="card-soft p-6 mt-6 space-y-4">
        <div><Label>Title *</Label><Input data-testid="fr-title" required value={form.title} onChange={change("title")} /></div>
        <div><Label>Organizer Name *</Label><Input data-testid="fr-organizer" required value={form.organizer_name} onChange={change("organizer_name")} /></div>
        <div><Label>Description *</Label><Textarea data-testid="fr-desc" required rows={5} value={form.description} onChange={change("description")} /></div>
        <div className="grid grid-cols-2 gap-4">
          <div><Label>Goal Amount (USD) *</Label><Input data-testid="fr-goal" required type="number" min="100" value={form.goal_amount} onChange={change("goal_amount")} /></div>
          <div><Label>Category *</Label><Input data-testid="fr-category" required value={form.category} onChange={change("category")} /></div>
        </div>
        <div><Label>Image URL</Label><Input data-testid="fr-image" value={form.image_url} onChange={change("image_url")} /></div>
        <button data-testid="fr-submit" disabled={busy} className="btn-pink">{busy ? "Creating..." : "Create Fundraiser"}</button>
      </form>
    </div>
  );
}
